/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { useApolloClient } from '@apollo/client';
import findContent from '../../../gql/queries/findContent';

const GraphqlRelationship = () => {
  const apolloClient = useApolloClient();
  const queryClient = useQueryClient();

  const QUERY_RELATIONSHIP = findContent({
    brand: 'global',
    locale: 'en-us',
    contentType: 'relationships',
  });

  const { data, isLoading, error } = useQuery({
    queryKey: ['relationships'],
    queryFn: async () => {
      const response = await apolloClient.query({ query: QUERY_RELATIONSHIP });
      return response.data;
    },
    staleTime: Infinity,
  });

    // Backup if GQL FAILS.
    // DO NOT change without verifying the CMS entries: Global stack -> Relationships content type
    const fallbackRelationships = [
        {
            locale: 'en-us',
            uid: 'blt0714c3e578efcedf',
            description: '',
            relationship_code: '0',
            title: 'Self',
        },
        {
            locale: 'en-us',
            uid: 'bltc2b2a1692999955e',
            description: '',
            relationship_code: '21',
            title: 'Family',
        },
        {
            locale: 'en-us',
            uid: 'bltcd32a82d4545a5ed',
            description: '',
            relationship_code: '2',
            title: 'Dad',
        },
        {
            locale: 'en-us',
            uid: 'blt882c066a8a74c298',
            description: '',
            relationship_code: '1',
            title: 'Mom',
        },
        {
            locale: 'en-us',
            uid: 'blt379d3dcacdd9359e',
            description: '',
            relationship_code: '17',
            title: 'Girlfriend',
        },
        {
            locale: 'en-us',
            uid: 'blt0b5b27245416be2c',
            description: '',
            relationship_code: '16',
            title: 'Boyfriend',
        },
        {
            locale: 'en-us',
            uid: 'blt83992fe8a28ffe03',
            description: '',
            relationship_code: '15',
            title: 'Wife',
        },
        {
            locale: 'en-us',
            uid: 'blt8ff3d01f3898c233',
            description: '',
            relationship_code: '14',
            title: 'Husband',
        },
        {
            locale: 'en-us',
            uid: 'bltd979550c18f82663',
            description: '',
            relationship_code: '20',
            title: 'Aunt',
        },
        {
            locale: 'en-us',
            uid: 'blta2ec45acc3cde3e7',
            description: '',
            relationship_code: '10',
            title: 'Uncle',
        },
        {
            locale: 'en-us',
            uid: 'bltf2f37a70e0589e0f',
            description: '',
            relationship_code: '8',
            title: 'Grandma',
        },
        {
            locale: 'en-us',
            uid: 'blt0d8a01dffb97bf8a',
            description: '',
            relationship_code: '7',
            title: 'Grandpa',
        },
        {
            locale: 'en-us',
            uid: 'blteff571af44942469',
            description: '',
            relationship_code: '6',
            title: 'Sister',
        },
        {
            locale: 'en-us',
            uid: 'bltf9b3b2ecd204e634',
            description: '',
            relationship_code: '5',
            title: 'Brother',
        },
        {
            locale: 'en-us',
            uid: 'blt111053a213136b72',
            description: '',
            relationship_code: '4',
            title: 'Daughter',
        },
        {
            locale: 'en-us',
            uid: 'bltf44f11df5a8e5e3b',
            description: '',
            relationship_code: '3',
            title: 'Son',
        },
        {
            locale: 'en-us',
            uid: 'bltcc2599b5335be88f',
            description: '',
            relationship_code: '18',
            title: 'Friend',
        },
        {
            locale: 'en-us',
            uid: 'bltcc5fbf689afae87a',
            description: '',
            relationship_code: '23',
            title: 'Client',
        },
        {
            locale: 'en-us',
            uid: 'blt372789b5be72dabe',
            description: '',
            relationship_code: '22',
            title: 'Colleague',
        },
        {
            locale: 'en-us',
            uid: 'blt50bc71357d16c5dc',
            description: '',
            relationship_code: '19',
            title: 'Other',
        },
    ];

  const processRelationships = (entries) => {
    const relationshipMapped = {};
    const relationshipMappedByValue = {};
    entries.forEach((relation) => {
      relationshipMapped[relation.relationship_code] = relation.title;
      relationshipMappedByValue[relation.title] = relation.relationship_code;
    });
    return { byId: relationshipMapped, byValue: relationshipMappedByValue };
  };

  useEffect(() => {
    if (!isLoading) {
      const relationshipsData =
        data?.findContent?.content?.entries?.length > 0
          ? processRelationships(data.findContent.content.entries)
          : error || !data?.findContent?.content?.entries
          ? processRelationships(fallbackRelationships)
          : null;

      if (relationshipsData) {
        queryClient.setQueryData(['relationships'], relationshipsData);
      }
    }
  }, [isLoading, data, error, queryClient]);

  return <></>;
};

export default GraphqlRelationship;
